import { useAssembly } from '../../../resources/assembly/assemblyHandler';

export const useIsPcbOnlyAssemblyType = (assemblyId: string) => {
    const { data: assembly } = useAssembly(assemblyId);
    if (assembly === undefined) return false;
    return assembly.type.type === 'PcbOnly';
};
